import { useContext } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { StoreContext } from '@provider/notifier';
import { useObservedValue, CSSRefTransition, SizeTransition } from '@utils/react';
import { Toast } from '../components/overlays/toast.js';
import { wrapper, container, containerTransitionDurationMs, item, itemTransitionDurationMs } from './organism.toast-container.style.js';
import { jsx } from 'react/jsx-runtime';

function ToastsContainer() {
  const store = useContext(StoreContext);
  const toasts = useObservedValue(store.refs.toasts);
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: toasts.length > 0 && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: containerTransitionDurationMs,
        classNames: container,
        delayMs: {
          enter: 60,
          exit: 0
        },
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: container,
          children: /*#__PURE__*/jsx(TransitionGroup, {
            component: null,
            children: toasts.map(notification => /*#__PURE__*/jsx(SizeTransition, {
              axis: "vertical",
              timeout: itemTransitionDurationMs,
              classNames: item,
              delayMs: {
                enter: 60,
                exit: 0
              },
              children: ref => /*#__PURE__*/jsx("div", {
                ref: ref,
                className: item,
                "data-state": notification.type,
                children: /*#__PURE__*/jsx(Toast, {
                  type: notification.type,
                  persistent: notification.persistent,
                  onClick: () => notification.onDismiss(),
                  cancelAutoDismiss: notification.cancelAutoDismiss,
                  children: notification.body
                })
              })
            }, notification.id))
          })
        })
      })
    })
  });
}

export { ToastsContainer };
//# sourceMappingURL=organism.toast-container.js.map
